export const PAGE_TYPE = "HomepageNext";

export const LANGUAGE_MODAL_SELECT_LANGUAGE_GTM = ["LanguageModal", "clicked"];
export const LANGUAGE_MODAL_SELECT_LANGUAGE_MP = "language_modal_select";

export const HERO_CHECK_COMPENSATION_GTM = ["Hero", "clicked", "CheckYourCompensation"];
export const HERO_CHECK_COMPENSATION_MP = "hero_check_compensation";

export const ANIMATED_CARD_GTM = ["AHPlusAnimatedCard", "clicked", "PricingPlan"];
export const ANIMATED_CARD_MP = "ah_plus_animated_card";
